import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { Pv1MoreDetailsDialogComponent } from '../pv1-more-details-dialog/pv1-more-details-dialog.component';

@Component({
  selector: 'kt-pv1-dialog',
  templateUrl: './pv1-dialog.component.html',
  styleUrls: ['./pv1-dialog.component.scss'],
})
export class Pv1DialogComponent {
  constructor(
    public dialogRef: MatDialogRef<Pv1DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}

  closeDialog() {
    this.dialogRef.close({ reload: true });
  }

  formatDate(date) {
    if (moment.isDate(new Date(date))) {
      return moment(date).format('MM-DD-YYYY');
    }
  }

  viewMoreDetail() {
    this.dialog.open(Pv1MoreDetailsDialogComponent, { data: this.data });
  }
}
